<template>
  <div class="exBranding-Detail">
    <template v-if="!isLoading && !loadingData">
      <div class="exBranding-Detail__title">
        <h1 class="xsmall-title">{{campaign.title}}</h1>
      </div>
      <div class="exBranding-Detail__period">
        <label-status class="status" :progress="displayStatus(campaign.status)"/>
        <span class="subhead period-text"> Campaign period</span>
        <span class="subhead">{{ displayPeriod(campaign.start, campaign.end) }}</span>
      </div>
      <div class="exBranding-Detail__table">
         <adx-table text="Tooltip button" 
          :loading.sync="isLoading"
          :items.sync="data"  
          :isEmpty.sync="isEmpty">
        </adx-table>
      </div>
      <div class="exBranding-Detail__range" v-if="!isLoading && !isEmpty">{{getDataRange}} of {{count}} Items</div>
      <!-- <div class="exBranding-Detail__footer">
        <adx-pagination 
          @change-page="selectPage" 
          :maxPage="maxPage" 
          :selectedPage="selectedPage" />
      </div> -->
    </template>
    <div v-else class="exBranding-Detail__loading">
      <adx-loading />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import Empty from '@/components/NotFound/Selection'
import Loading from '@/components/Loading/Primary'
import LabelStatus from '@/components/StatusLabel'
import table from '@/components/Table'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import lib from '@/lib/util'
import { helpers } from '@/lib/validation/'

export default {
  name: 'adx-dashboard-campaign-detail',
  components: {
    'adx-pagination': Pagination,
    'adx-empty': Empty,
    'adx-loading': Loading,
    'label-status': LabelStatus,
    'adx-table': table
  },
  props: {

  },
  data() {
    return {
      searchText: '',
      selectedPage: 1,
      maxPage: 1,
      campaignId: null,
      campaign: {
        title: '',
        start: '',
        end: '',
        status: '',
        devices: []
      },
      campaignStatus:{
        label: 'ACTIVE',
        value: 'active'
      },
      count: 0,
      isLoading: false,
      loadingData: false,
      data: {
        checkbox: false,
        head: [
          {
            title: "ID",
            type: "text",
            display: "display:none;"
          },
          {
            title: "LOCATION",
            type: "description"
          },
          {
            title: "PLACEMENT",
            type: "text"
          },
        ],
        body : []
      },
    }
  },
  computed: {
    isEmpty: function(){
      return this.data.body && this.data.body.length? false: true
    },
    getDataRange: function(){
      return (this.count%15===0 || this.selectedPage===1) && this.count>15?this.selectedPage*15:(this.selectedPage*15-15)+(this.count%15)
    },
  },
  watch: {
    searchText: helpers.debounce(function () {
      this.$nextTick(function () {
        this.getCampaignDetail()
      })
    }, 500),
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.campaignId = this.$route.params.id
    this.isLoading = true
    this.getCampaignDetail()
    this.isLoading = false
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    focusSearch() {
      this.$refs.inputSearch.focus()
    },
    selectPage(page) {
      this.selectedPage = page
      this.getCampaignDetail()
    },
    goToAllCampaign() {
      this.$router.push({ name: 'advertiser' })
    },
    getCampaignDetail() {
      (async () => {
        this.loadingData = true
        let param = {}
        param.page = this.selectedPage
        if (this.searchText) {
          param.search = this.searchText
        }
        let response = await api.get(apiV2.dashboardStaticExperienceBranding(this.campaignId), {needToken: true})
        if (response.status == 200) {
          let data = response.data.static_campaign
          this.campaign = response.data
          // this.maxPage = data.max_page
          this.mappingData(data)
          this.loadingData = false
        } 
      })();
    },
    async mappingData(data){
      let body = [];
      let result = data;
      // await result.map(async static_campaign => {
        let listing = data.listing_set
        await listing.map(res => {
          let valuesData = [
            { value: res.id, display: "display:none;"},
            { header: true, 
              items:[
                { value: res.location},
                { value: data.title}
              ]
            },
            { value: res.placement},
          ];
          body.push({
            id: res.id,
            values:valuesData
          });
        // });
      })
      
      this.data.body = body;
      this.count = body.length;
      this.isLoading = false
    },
    displayPeriod(start, end) {
      return `${lib.formatShortDate(start)} - ${lib.formatShortDate(end)}`
    },
    displayStatus(status) {
      return lib.displayLabelStatus(status)
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>